module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "location-container",
    on: {
      "click": _vm.changeBoardState
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.curLocation))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e7c1918"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/map_module/maptool/toolbar/location.vue
// module id = 38
// module chunks = 0